var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalleryAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3166 16.8923C17.1257 16.8923 18.5922 15.439 18.5922 13.6462C18.5922 11.8534 17.1257 10.4 15.3166 10.4C13.5076 10.4 12.041 11.8534 12.041 13.6462C12.041 15.439 13.5076 16.8923 15.3166 16.8923Z",
    stroke: "white",
    strokeWidth: 2.16374,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8679 3.90771H15.3167C7.12767 3.90771 3.85205 7.15387 3.85205 15.2693V25.0077C3.85205 33.1231 7.12767 36.3693 15.3167 36.3693H25.1435C33.3326 36.3693 36.6082 33.1231 36.6082 25.0077V16.8923",
    stroke: "white",
    strokeWidth: 2.16374,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3716 8.77692H35.3795",
    stroke: "white",
    strokeWidth: 2.16374,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8755 13.2404V4.31348",
    stroke: "white",
    strokeWidth: 2.16374,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94922 31.4189L13.0236 26.0465C14.3175 25.1863 16.1846 25.2837 17.3474 26.2737L17.8879 26.7444C19.1654 27.8319 21.229 27.8319 22.5065 26.7444L29.3198 20.9501C30.5973 19.8626 32.6609 19.8626 33.9384 20.9501L36.608 23.2224",
    stroke: "white",
    strokeWidth: 2.16374,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryAdd);
export default __webpack_public_path__ + "static/media/gallery-add.7fd07d42b6ed446fa10cc128e7528d60.svg";
export { ForwardRef as ReactComponent };